export default __webpack_public_path__ + "static/media/icon-historia-completada.d639d476.svg";